import { css } from '@emotion/react';

import { SasIcon } from './SasIcon';
import { theme } from './theme';

interface ErrorMessageProps {
  message: string;
  highlighted?: boolean;
  className?: string;
}

const errorMessageContainer = css`
  display: flex;
  width: 100%;
  gap: ${theme.spacing.xs};
  align-items: center;

  & > svg {
    color: ${theme.colors.danger};
  }
  & > p {
    font-size: ${theme.fontSize.xs};
  }
`;

const highlightedErrorMessage = css`
  padding: ${theme.spacing.md};
  border: 2px solid ${theme.colors.danger};
  border-radius: ${theme.borders.radius.sm};
  align-items: flex-start;

  & > p {
    color: ${theme.colors.danger};
    font-size: ${theme.fontSize.sm};

    &::first-letter {
      text-transform: capitalize;
    }
  }
`;

export const ErrorMessage = ({ message, highlighted = false, className }: ErrorMessageProps) => {
  const styling = highlighted ? [errorMessageContainer, highlightedErrorMessage] : errorMessageContainer;
  return (
    <div css={styling} className={className}>
      <SasIcon name="cl--alert-circle" color={theme.colors.danger} />
      <p>{message}</p>
    </div>
  );
};
